import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import Container from '../Container';
import HeaderMenu from '../../containers/HeaderMenu';
import Logo from '../Logo';

import { srOnly } from '../../base-styles/mixins.module.css';

import {
  container,
  header as opaqueHeader,
  logo,
  menu,
  transparentHeader,
} from './styles.module.css';

/**
 * Header presentational component.
 */
const Header = ({ transparent }) => (
  <header className={[transparent ? transparentHeader : opaqueHeader].join(' ')} role="banner">
    <Container className={container}>
      <div className={srOnly}>Let’s Do This</div>
      <Link to="/" className={logo} title="Let’s Do This">
        <Logo inverse={transparent} />
      </Link>
      <HeaderMenu transparent={transparent} className={menu} />
    </Container>
  </header>
);

Header.propTypes = {
  /**
   * Boolean whether to use transparent styles.
   */
  transparent: PropTypes.bool,
};

Header.defaultProps = {
  transparent: false,
};

export default Header;



// WEBPACK FOOTER //
// ./app/src/components/Header/index.jsx